import { render, staticRenderFns } from "./SubscribeToNewsletterBlock.vue?vue&type=template&id=a4b93460"
import script from "./SubscribeToNewsletterBlock.vue?vue&type=script&lang=js"
export * from "./SubscribeToNewsletterBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports